module.exports = __webpack_public_path__ + "img/unlock-button.13f46af5.png";